import React, { useEffect, useState } from "react";
import { FormControlLabel, Grid, Switch } from "@material-ui/core";
import { WebcamCard } from "../components/home/WebcamCard";
import {WebcamCardMediapipeDonateSign} from "../components/donateSign/WebcamCardMediapipeDonateSign"
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { DonateSignRecordingButton } from "../components/donateSign/DonateSignRecordingButton";
import { Button } from "@mui/material";
import { VideoTimer } from "../api/VideoTimer";
import { checkCameraPermissions, saveVideo } from "../api/utils/webcam";
import { useVideo } from "../api/VideoProvider";
import { CountdownTimer } from "../components/home/CountdownTimer";
import { CameraPermissionsPrompt } from "../components/home/CameraPermissionsPrompt";
import { pRecordTime, pStatus, pMediapipeHandDetected, pDonateSignButtonsOptions, pRemoteControlOptions, pRepetitionRecord } from "../utils/parameters";
//import Switch from "react-switch";
import { useSnackbar } from "notistack";
//import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
//import FaceRetouchingOffIcon from "@mui/icons-material/FaceRetouchingOff";
import SelectAllIcon from '@mui/icons-material/SelectAll';
import DeselectIcon from '@mui/icons-material/Deselect';
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import useMediaQuery from "@mui/material/useMediaQuery";
import device from "current-device";
import FastForwardIcon from '@mui/icons-material/FastForward';
import { useDataProvider } from "../api/DataProvider";  
import { pDataProvider } from "../utils/parameters";
import Tooltip from '@mui/material/Tooltip';
import { useTour } from "@reactour/tour";
import { stepsRecordVariant } from "../components/tour/TourConfig";
import { useCommProvider } from "../api/CommProvider";
import { SimpleVideoDialog } from "../components/donateSign/SimpleVideoDialog";
import { SettingsDialog } from "../components/donateSign/SettingsDialog";
import SettingsIcon from '@mui/icons-material/Settings';
import SwipeUpIcon from '@mui/icons-material/SwipeUp';
import { WebcamSelection } from "../components/home/WebcamSelection";
import { useTranslation } from "react-i18next";
import { DeviceQueries } from "../components/utils/DeviceQueries";


import HelpSnackbar from "../components/utils/HelpSnackbar";
var lodash = require('lodash');

import "../styles/devices/mob_Home.css";
import "../styles/devices/mob_Collaborator.css";
import "../styles/devices/mob_Game.css";



export function DonateSign() {

  const { comm_getDonateSign } = useCommProvider();
  const { t } = useTranslation("global")
  
  const [mediaBlobUrl, setMediaBlobUrl] = useState("");
  /* Devices */
  const [deviceId, setDeviceId] = useState({});
  const [reportCameraIndex, setReportCameraIndex] = useState({});
  /* Contexts */
  const { recTime, setRecTime, faceStatus, setFaceStatus, cameraPermissions, setCameraPermissions } = useVideo();
  // const [timer, setTimer] = useState(pRecordTime.default);
  /* Snackbar */
  const [snack, setSnack] = useState({ open: false, text: "" });
  const [switchGalibo, setSwitchGalibo] = useState(true);
  const [switchSide, setSwitchSide] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const { comm_sendDonateSign } = useCommProvider();
  const { token_id, currentUser } = useDataProvider();
  const { json_data_lemma, json_data_meaning, json_data_glosses, comm_getPublicURLVideoData } = useDataProvider();

  const [openDialog, setOpenDialog] = useState(false);
  const [selected_video, setSelected_video] = useState("");
  const [selected_label, setSelected_label] = useState("");
  const [location, setLocation] = useState({});
  const [gloss_id_requested, set_gloss_id_requested] = useState("");

  const [activateMediapipe, setActivateMediapipe] = useState(false)
  const [pauseMediapipe, setPauseMediapipe] = useState(false)
  const [handDetected, setHandDetected] = useState(pMediapipeHandDetected.NONE)
  const [handDetectedArray, setHandDetectedArray] = useState(Array(5).fill(pMediapipeHandDetected.NONE));

  const [positionHandIconButton, setPositionHandIconButton] = useState({
    [pDonateSignButtonsOptions.NEXT]: pMediapipeHandDetected.RIGHT,
    [pDonateSignButtonsOptions.REPEAT]: pMediapipeHandDetected.LEFT,
  });


  // Params to configurate
  const [ openSettings, setOpenSettings ] = useState(false);
  const [ settings, setSettings ] = useState(
        {'repetitions_video': 1, 
        'speedCountDownTimer': 1, 
        'timer': pRecordTime.default,
        'gacebo': switchGalibo,
        'enable_discard': false,
        // 'hand_left': 'START',
        // 'hand_right': 'REPEAT',
        'mode_remote': pRemoteControlOptions.NORMAL,
        'repeat_after_record': pRepetitionRecord.ONE_REPETITION,
      });

  /* MOB - Nav responsiveness */
  const queryMatches = DeviceQueries();

  useEffect(() => {
    return () => {
      setFaceStatus(pStatus.init)
    };
  }, []);

  
  /* Check device & Camera permissions */
  useEffect(() => {
    /* Only check if there are no camera permissions */
    if (!cameraPermissions.cam) {
      /* Status and permissions prompt */
      setCameraPermissions({ ...cameraPermissions, perm: false });
      setFaceStatus(pStatus.error);
      /* Check permissions again */
      checkCameraPermissions()
        .then((r) => {
          setCameraPermissions({ ...cameraPermissions, perm: r, cam: r });
          r ? setFaceStatus(pStatus.init) : setFaceStatus(pStatus.error);
        })
        .catch((e) => setCameraPermissions({ ...cameraPermissions, perm: false, cam: false }));
    }
    // eslint-disable-next-line
  }, []);


  /* Snackbars with info */
  useEffect(() => {
    // console.log('faceStatus: ',faceStatus)

      switch (faceStatus) {
        case pStatus.runTf:
          setSnack({ ...snack, open: true, text: t("sRecordComponent.setFace"), type: "info" });
          break;
        case pStatus.countdown:
          setSnack({ ...snack, open: true, text: t("sRecordComponent.recording"), type: "info" });
          break;
        case pStatus.record:
            setPauseMediapipe(true)
            break;
        default:
          setPauseMediapipe(false)
          break;
      }

      /* eslint-disable-next-line */
  }, [faceStatus]);

  // This function has been repurposed, check if the facial detection is going to be used eventually
  function toggleGalibo() {
    if (switchGalibo) {
      //enqueueSnackbar("Se ha desactivado la detección facial.", { variant: "warning" });
      enqueueSnackbar("Se ha desactivado la ayuda al encuadre.", { variant: "warning" });
    } else {
      //enqueueSnackbar("Se ha activado la detección facial.", { variant: "success" });
      enqueueSnackbar("Se ha activado la ayuda al encuadre.", { variant: "success" });
    }
    setSwitchGalibo((galibo) => !galibo);
  }

  function toggleSide() {
    setSwitchSide((side) => !side);
  }

  /* Tour */
  function handleOpenTour(steps, initStep) {
    setSteps(steps);
    setCurrentStep(initStep);
    setIsOpen(true);
  }

  /* PROGRAMACIÓN DE LA LÓGICA DEL COMPONENTE */

  /* Send video to server */
  async function send2ServerDonateSign() {
  
    if (Object.keys(location).length > 0) {
      const videoFile = await saveVideo(mediaBlobUrl);
      const locationLabels = {
          'lemma': json_data_lemma[location['lemma']]['label'],
          'meaning': json_data_meaning[location['meaning']]['label'],
          'gloss': json_data_glosses[location['gloss']]['label'],
        }
      
      // console.log("🚀 ~ file: DonateSign.js:219 ~ send2ServerDonateSign ~ location['lemma']:", location['lemma'])
      // console.log("🚀 ~ file: DonateSign.js:219 ~ send2ServerDonateSign ~ json_data_lemma[location['lemma']]:", json_data_lemma[location['lemma']])
      // console.log("🚀 ~ file: DonateSign.js:219 ~ send2ServerDonateSign ~ json_data_lemma[location['lemma']]['label']:", json_data_lemma[location['lemma']]['label'])

      await comm_sendDonateSign(token_id, currentUser, location, locationLabels, videoFile);
    }else{
      console.log('location is empty')
    }
    // setFaceStatus(pStatus.init);
  }

  async function requestNewVideo(){
    // console.log('request new video')
    setFaceStatus(pStatus.init)
    set_gloss_id_requested(await comm_getDonateSign(token_id, currentUser))
  }

  useEffect(() => {
    setFaceStatus(pStatus.init)
    return () => { setFaceStatus(pStatus.init) };
  },[])


  useEffect(() => {

    console.log('gloss_id_requested: ', gloss_id_requested)

    if (gloss_id_requested['gloss_id'] !== undefined ){
      
      const gloss_id = gloss_id_requested['gloss_id']
      
      let arr_elements_meanings = []
      if (json_data_glosses[gloss_id][pDataProvider.arr_meanings].length > 0) {
        json_data_glosses[gloss_id][pDataProvider.arr_meanings].forEach(meaning_id => {
          arr_elements_meanings.push(meaning_id)
        });
      } 
      if (json_data_glosses[gloss_id][pDataProvider.arr_variants].length > 0) {
        json_data_glosses[gloss_id][pDataProvider.arr_variants].forEach(meaning_id => {
          arr_elements_meanings.push(meaning_id)
        });
      }

      const meaning_id = lodash.sample(arr_elements_meanings);
      const lemma_id = lodash.sample(json_data_meaning[meaning_id][pDataProvider.arr_lemmas])

      setSelected_label(json_data_lemma[lemma_id]['label'])
      // setSelected_video(json_data_glosses[gloss_id]['url_vid_sign'])
      setSelected_video(comm_getPublicURLVideoData(pDataProvider.dir_vid_sign, gloss_id))


      setLocation({
        lemma: lemma_id,
        meaning: meaning_id,
        gloss: gloss_id,
      })
      setOpenDialog(true);
    }
    
  }, [gloss_id_requested])



  const handleButtonStart = () => {
    setFaceStatus(pStatus.init);
    send2ServerDonateSign();
    requestNewVideo();
  }

  const handleButtonRepeat = () => {
    setFaceStatus(pStatus.init)
    setOpenDialog(true);
  };

  const handleButtonDiscard = () => {
    requestNewVideo();
  };

  const handleCloseDialog = () => {

    // console.log('cerrar dialogo')
    // console.log('openDialog', openDialog)
    // console.log('selected_video', selected_video)
    // console.log('selected_label', selected_label)
    setOpenDialog(false);
    
    if (selected_video !== "" && selected_label !== ""){
      // console.log('termino de mostrar el vídeo a grabar e iniciar proceso de grabación')
  
      // console.log('start record')
      setRecTime(settings.timer);
      // console.log(pStatus.countdown);
      // switchGalibo ? setFaceStatus(pStatus.runTf) : setFaceStatus(pStatus.countdown);
      setFaceStatus(pStatus.countdown);
    }

  };



  const handleSwitchModeAutomatic = () => {

    // console.log("🚀 ~ file: DonateSign.js:315 ~ handleSwitchModeAutomatic ~ handleSwitchModeAutomatic:", handleSwitchModeAutomatic)

    
    const activateMediapipe_new = !activateMediapipe;
    setActivateMediapipe(activateMediapipe_new)
    setPauseMediapipe(!activateMediapipe_new)
  }
 

  const handleOpenSettings = () => {
    setOpenSettings(true);
  };

  const handleCloseSettings = () => {
    setOpenSettings(false);
  };

  // useEffect(() => {
  //   console.log("Apply new settings");
  //   console.log(settings);

  //   //setSwitchGalibo(settings['switch_galibo']);
  //   //setRecTime(settings['rec_time']);
    
  // }, [settings]);


  useEffect(() => {
    console.log("🚀 ~ file: DonateSign.js:320 ~ DonateSign ~ handDetected:", handDetected)  
  }, [handDetected])
  

  
  useEffect(() => {
    console.log("🚀 ~ file: DonateSign.js:330 ~ DonateSign ~ reportCameraIndex:", reportCameraIndex)
    if (reportCameraIndex !== 0) {
      setActivateMediapipe(false)
      setPauseMediapipe(true)
    }
  }, [reportCameraIndex])
  
  

  // useEffect(() => {
  //   console.log("HAND DETECTED: ",handDetected);
  // }, [handDetected]);
  

  
  return (
    <HomeWrapper>
      <SimpleVideoDialog openDialog={openDialog} selected_video={selected_video} selected_label={selected_label} handleClickClose={handleCloseDialog} repetitions_video={settings['repetitions_video']}/>
      <SettingsDialog openDialog={openSettings} handleClickClose={handleCloseSettings} settings={settings} setSettings={setSettings}/>
      <Grid className={`sig_Home_MainSectionContainer ${queryMatches.deviceLandscape ? "sig_Home_MSCLandscape" : ""}`} container>
        <Grid item className={`sig_Home_Options sig_Home_Options${switchSide ? "Right" : "Left"}`}>
          {queryMatches.desktop ? (
            <Grid container className="sig_Home_MainSectionOptions"> 
              <Tooltip title={ activateMediapipe ? t("sTooltip.info_turn_off_remote") : t("sTooltip.info_turn_on_remote") } placement="right" arrow>
                <Button data-tour="tourCam_2b" onClick={handleSwitchModeAutomatic} disabled={reportCameraIndex!=='0'} className={`sig_Home_ChangeOnDarkMode ${!activateMediapipe? "sig_Game_Terms_ReturnButton" : "sig_Game_Terms_ReturnButton_Inv"}`} variant="contained">
                  <SwipeUpIcon className="sig_Game_AutoIcon" /> {t("remote_mode").toUpperCase()}
                </Button>
              </Tooltip>
              <WebcamSelection deviceId={deviceId} setDeviceId={setDeviceId} userConfig={false} permissions={cameraPermissions.cam} setReportCameraIndex={setReportCameraIndex}/>            
              <Tooltip title={t("sTooltip.settings")} placement='top' arrow>
                <div data-tour='tourCam_4' className="sig_Main_IconButton" onClick={handleOpenSettings}>
                  <SettingsIcon></SettingsIcon>
                </div>
              </Tooltip>
              {/* <Tooltip title={t("sTooltip.help_framing")} placement='top' arrow>
                <div data-tour='tourCam_4' className="sig_Main_IconButton" onClick={() => toggleGalibo()}>
                  {switchGalibo ? <SelectAllIcon className="sig_Home_ChangeOnDarkMode" /> : <DeselectIcon className="sig_Home_ChangeOnDarkMode" />}
                </div>
              </Tooltip> */}
            </Grid>
          ) : queryMatches.devicePortrait ? (
            <>             
            <Button data-tour="tourCam_2b" onClick={handleSwitchModeAutomatic} className="sig_Game_Terms_ReturnButton sig_Game_Terms_ReturnButtonFullWidth sig_Home_ChangeOnDarkMode" variant="contained">
              <FastForwardIcon className="sig_Game_AutoIcon" /> MODO AUTOMÁTICO
            </Button>
            </>
          ) : <></>
          }
          <Grid container className={`sig_Home_MainSectionCamera ${queryMatches.deviceLarge ? "sig_Home_MainSectionCamera_LargeDevice" : ""}`}>
            <Grid item>
              <WebcamCardMediapipeDonateSign devicePortrait={queryMatches.devicePortrait} desktop={queryMatches.desktop} deviceLarge={queryMatches.deviceLarge} setVideo={setMediaBlobUrl} settings={settings} permissions={cameraPermissions.cam} activateMediapipe={activateMediapipe} setHandDetectedArray={setHandDetectedArray} handDetected={handDetected} pauseMediapipe={pauseMediapipe} deviceId={deviceId} switchGalibo={switchGalibo}>
                <CountdownTimer settings={settings}/>
                {!cameraPermissions.perm && <CameraPermissionsPrompt />}
              </WebcamCardMediapipeDonateSign>
            </Grid>
          </Grid>
          <Grid container className={`sig_Home_MainSectionButtons ${queryMatches.deviceLarge ? "sig_Home_MainSectionButtons_LargeDevice" : ""}`}>
            {queryMatches.desktop ? (
              <>
              <Grid item className="sig_Home_ProgressContainer">
                <VideoTimer />
              </Grid>
              </>
            ) : (
              <Grid container className="sig_Home_MainSectionOptions">
              {queryMatches.deviceLandscape ? (
                <>
                <FormControlLabel
                  control={
                    <>
                      <SyncAltIcon className="sig_Home_ChangeOnDarkMode" />
                      <Switch color="primary" onClick={toggleSide} checked={switchSide} />
                    </>
                  }
                />
                </>
              ) : (
                <>
                <WebcamSelection deviceId={deviceId} setDeviceId={setDeviceId} userConfig={false}  permissions={cameraPermissions.cam} />
                </>
              )
              }     
              <Tooltip title={t("remote_mode")} placement="top" arrow>
                <div data-tour="tourCam_1" className="sig_Main_IconButton" disabled={activateMediapipe} onClick={handleSwitchModeAutomatic}>
                  <FastForwardIcon className="sig_Home_ChangeOnDarkMode"/>
                </div>
              </Tooltip>    
              <Tooltip title={t("sTooltip.settings")} placement='top' arrow>
                <div data-tour='tourCam_4' className="sig_Main_IconButton" onClick={handleOpenSettings}>
                  <SettingsIcon></SettingsIcon>
                </div>
              </Tooltip>
              <Tooltip title={t("sTooltip.help_framing")} placement='top' arrow>
                <div data-tour='tourCam_4' className="sig_Main_IconButton" onClick={() => toggleGalibo()}>
                  {switchGalibo ? <SelectAllIcon className="sig_Home_ChangeOnDarkMode" /> : <DeselectIcon className="sig_Home_ChangeOnDarkMode" />}
                </div>
              </Tooltip>
              </Grid>
            )}
            <Grid item className="sig_Home_ButtonsContainerOuter">
              <DonateSignRecordingButton settings={settings} enableDiscardButton={settings['enable_discard']} handleButtonStart={handleButtonStart} handleButtonDiscard={handleButtonDiscard} handleButtonRepeat={handleButtonRepeat} switchGalibo={switchGalibo} positionHandIconButton={positionHandIconButton} handDetectedArray={handDetectedArray} setHandDetected={setHandDetected} activateMediapipe={activateMediapipe} pauseMediapipe={pauseMediapipe}>   
              {queryMatches.deviceLandscape ? (
                  <>
                  <WebcamSelection deviceId={deviceId} setDeviceId={setDeviceId} userConfig={false} permissions={cameraPermissions.cam} />
                  <Grid item className="sig_Home_ProgressContainer">
                    <VideoTimer />
                  </Grid>
                  </>
                  ) : queryMatches.devicePortrait ? (
                  <>
                  <Grid item className="sig_Home_ProgressContainer">
                    <VideoTimer />
                  </Grid>
                  </>
                  ) : (<>
                  </>
                )}
              </DonateSignRecordingButton>
            </Grid>
          </Grid>
          <HelpSnackbar snack={snack} setSnack={setSnack} />
        </Grid>
      </Grid>
    </HomeWrapper>
  );
}
